module.exports = __webpack_public_path__ + "static/media/play-icon.87614735.svg";